export default {
  noData: {
    summary: 'Nenašli sa žiadne dáta',
  },
  noAccess: 'Používateľ nemá prístup',
};
